import type { ImageModel } from '@rocco/types/image-model';
import type { TileableModel } from '@rocco/ui/tile-shared/view-models/tile';

export interface ProductPriceTileViewModel {
    amount: number;
    discountedAmount: number;
    currency: 'NZD' | 'AUD';
    prefix?: string;
}

export interface ProductVariantTileViewModel {
    color: string;
    image: ImageModel;
}

export interface ProductTileViewModel {
    id: number;
    title: string;
    images: ImageModel[];
    video: string[];
    link: string;
    price: ProductPriceTileViewModel | null;
    variants: ProductVariantTileViewModel[] | null;
    hasAwards: boolean;
    draft: boolean;
    badge: string | null;
    pendingApproval: boolean;
    canPurchase: boolean;
    professional: {
        id: number;
        name: string;
        link: string;
    };
    seoDescription: string;
    /**
     * The item's tracked external website link, or null/absent when it has none.
     * Resolved server-side with the same fallback the detail-page CTA uses (a
     * product's own Website, else the professional's) and already carries the
     * UTM / `_ap_pageid` params. Only populated on surfaces that fetch it.
     */
    website?: string | null;
    canEdit?: boolean;
    bmEditorLink?: string;
    repositionThumbLink?: string;
}

export const isProductTileViewModel = (
    model: TileableModel,
): model is ProductTileViewModel =>
    model && 'price' in model && 'variants' in model;
